module.exports = __webpack_public_path__ + "img/Forma -1.ddff3c90.svg";